"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Title = _interopRequireDefault(require("../../Title"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable @typescript-eslint/prefer-optional-chain */

/** *
 * origin component
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var FlexCard = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props || {},
      icon = _a.icon,
      banner = _a.banner,
      sharp = _a.sharp,
      radius = _a.radius,
      configuration = _a.configuration,
      flexTitle = _a.flexTitle,
      description = _a.description,
      style = _a.style,
      className = _a.className,
      onClick = _a.onClick,
      restProps = __rest(_a, ["icon", "banner", "sharp", "radius", "configuration", "flexTitle", "description", "style", "className", "onClick"]);

  var compatibleArr = configuration || [];
  var cols3 = [3, 5, 6, 9, 12, 15, 18, 21].includes(configuration.length);

  if (cols3) {
    compatibleArr = configuration && configuration.length % 3 ? __spreadArrays(configuration, new Array(3 - configuration.length % 3).fill({
      supplement: true
    })) : configuration;
  } else if (configuration.length > 6 && !cols3) {
    compatibleArr = configuration && configuration.length % 4 ? __spreadArrays(configuration, new Array(4 - configuration.length % 4).fill({
      supplement: true
    })) : configuration;
  }

  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'flex-default-card-class-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-card-class-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: description
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-card-class-container-children__article', {})
  }, compatibleArr && compatibleArr.map(function (items, index) {
    var _a = items || {},
        imageSrc = _a.imageSrc,
        article = _a.article,
        title = _a.title,
        href = _a.href,
        supplement = _a.supplement;

    var _b = (0, _utils.fomateFileData)(imageSrc),
        url = _b.url,
        _c = _b.alt,
        alt = _c === void 0 ? '' : _c;

    return /*#__PURE__*/_react["default"].createElement("section", {
      key: index,
      className: (0, _classnames["default"])('flex-card-list', {
        'flex-card-list-col3': cols3,
        'flex-card-list-col4': configuration.length > 6 && !cols3,
        'flex-card-list--status': supplement
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-card-image', {})
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-default-article', className),
      onClick: function onClick() {
        if (!href) return;
        window.location.href = href;
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-default-article-container', {})
    }, /*#__PURE__*/_react["default"].createElement("section", {
      style: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        wordBreak: 'break-word'
      }
    }, title && /*#__PURE__*/_react["default"].createElement("strong", {
      className: "wordBreak line-break4"
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-div-content line-break9",
      dangerouslySetInnerHTML: {
        __html: article
      }
    }))))));
  }))));
});
FlexCard.displayName = 'TCIThumbnail';
var _default = FlexCard;
exports["default"] = _default;